import { initializeEDCFlow } from "@smvtech/x-flux";
import { API_BASE_URL } from "../../../env";

export const initEDCFlow = () => {
	const jwtToken = sessionStorage.getItem("jwt-token") || "";

	let environment: "PROD" | "STAG" | "LOCAL" = "LOCAL";
	if(API_BASE_URL.includes("qa.stampmyvisa.com")) {
		environment = "STAG";
	} else if (API_BASE_URL.includes("live.stampmyvisa.com")) {
		environment = "PROD";
	} else {
		environment = "LOCAL";
	}

	const baseUrls = {
		STAG: "https://api.qa.stampmyvisa.com",
		PROD: "https://api.live.stampmyvisa.com",
		LOCAL: API_BASE_URL
	};

	initializeEDCFlow({
		baseUrls,
		environment,
		jwtToken
	});
};

